import { render, staticRenderFns } from "./ReceiptEditAddRegular.vue?vue&type=template&id=07d8f6ba&"
import script from "./ReceiptEditAddRegular.vue?vue&type=script&lang=ts&"
export * from "./ReceiptEditAddRegular.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptEditAddRegular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
